import styled, { css } from "styled-components"
import Image from "components/atoms/Image"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.color.white};
  position: relative;
  margin-bottom: 3.2rem;
  width: 15.6rem;
  height: 12.8rem;
  cursor: pointer;

  &:hover img {
    transform: scale(1.1);
  }

  &:nth-of-type(even) {
    margin-left: auto;
  }

  ${({ theme }) => theme.mq.medium} {
    width: 16.8rem;
    height: 13.6rem;
    margin: 0 0 3.6rem;

    &:nth-of-type(even) {
      margin-left: 0;
    }
  }
`
const StyledImg = styled(Image)`
  object-fit: cover;
  transition: transform 0.3s linear;
  height: 100%;
  width: 100%;
`
const StyledOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #196be6b3;
  width: 100%;
  height: 100%;
  display: none;
  align-items: center;
  justify-content: center;
`

const StyledImgWrapper = styled.div`
  overflow: hidden;
  height: 67%;
  position: relative;
  justify-content: center;
  display: flex;
  align-items: center;

  ${({ isSelected }) =>
    isSelected &&
    css`
      ${StyledOverlay} {
        display: flex;
      }
    `};
`

const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 0.8rem;
  justify-content: space-between;
  height: 33%;
`
const StyledTitle = styled.p`
  font-size: ${({ theme }) => theme.font.size.s};
  line-height: 1.71;
  color: ${({ theme }) => theme.color.secondary01};
`
const StyledAddress = styled.span`
  font-size: ${({ theme }) => theme.font.size.xs};
  line-height: 1.67;
  letter-spacing: 0.25px;
  color: ${({ theme }) => theme.color.secondary02};
`

export {
  StyledWrapper,
  StyledImg,
  StyledTextWrapper,
  StyledTitle,
  StyledAddress,
  StyledImgWrapper,
  StyledOverlay,
}
